import { Slot } from "@radix-ui/react-slot"
import clsx from "clsx"
import type { ReactNode } from "react"

import type { SX } from "../../theme"
import { Text } from "../Text"
import styles from "./Tab.module.css"

export interface TabProps {
  children: ReactNode
  asChild?: boolean
  selected?: boolean
  outline?: boolean
  transparent?: boolean
  noWrap?: boolean
  sx?: SX
  onClick?: () => void
}

export function Tab(props: TabProps) {
  const {
    children,
    asChild,
    outline,
    selected = false,
    transparent = false,
    noWrap = false,
    sx,
    onClick
  } = props

  const TabComponent = asChild ? Slot : "button"

  const className = clsx(
    styles.tab,
    selected ? styles.selected : styles.unselected,
    transparent && styles.transparent,
    outline && styles.outline,
    noWrap && styles.noWrap
  )

  return (
    <Text
      display="inline-flex"
      component="span"
      variant="bold"
      color={selected ? "purple9" : "grey11"}
      sx={sx}
    >
      <TabComponent className={className} onClick={onClick}>
        {children}
      </TabComponent>
    </Text>
  )
}
